<template>
  <div>
    <v-row class="pl-3">
      <h2><span class="blue-grey--text text--darken-1">Kennel: </span>{{ registration.kennelName }} (ID: {{ registration.kennelId }})</h2>
    </v-row>
    <v-row>
      <v-col cols="12" sm="6">
        <h2 class="blue-grey--text text--darken-1">Current Owners:</h2>
        <CoownersList
          :owners="registration.currentOwners"
          :ownershipType="kennelOwnershipType"
          :hideHeader="true"
        />
      </v-col>
      <v-divider vertical light class="d-none d-sm-flex"></v-divider>
      <v-col cols="12" sm="6">
        <h2 class="blue-grey--text text--darken-1">New Owners:</h2>
        <CoownersList
          :owners="registration.newOwners"
          :ownershipType="kennelOwnershipType"
          :hideHeader="true"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

export default Vue.extend({
  name: "ChangeKennelOwners",
  components: {
    CoownersList,
  },
  props: {
    registration: { type: Object },
  },
  computed: {
    kennelOwnershipType: function () {
      return OwnershipType.Kennel;
    },
  },
});
</script>